<template>
  <div class="flex flex-col gap-y-3">
    <button
      :class="{ 'text-primary bg-primary/30': matchedRoute.includes(menuItemWithTogglers.path) }"
      class="w-full flex gap-x-4 items-center hover:text-primary hover:bg-primary/30 py-3 px-4"
      @click="menuItemWithTogglers.toggleFunc?.func()"
    >
      <faChevronRight
        :class="{ 'rotate-90': menuItemWithTogglers.toggleFunc.value.value }"
        class="w-3 fill-primary"
      />
      {{ $t(menuItemWithTogglers.label) }}
    </button>
    <div
      v-if="menuItemWithTogglers.toggleFunc.value.value"
      class="hello ps-4 flex flex-col gap-y-3"
    >
      <template :key="key" v-for="(child, key) in menuItemWithTogglers.children">
        <SubmenuBuilder v-if="'children' in child" :menu-item="child"></SubmenuBuilder>
        <template v-else>
          <button
            v-if="'on_click' in child"
            :class="{ 'text-primary bg-primary/30': matchedRoute.includes(child.path) }"
            class="flex gap-x-4 items-center hover:text-primary hover:bg-primary/30 py-3 px-4"
            @click="handleAction(child)"
          >
            <faChevronRight class="w-3 fill-primary" />
            {{ $t(child.label) }}
          </button>
          <RouterLink
            v-else
            :key="key"
            :to="child.path"
            :class="{ 'text-primary bg-primary/30': matchedRoute.includes(child.path) }"
            class="flex gap-x-4 items-center hover:text-primary hover:bg-primary/30 py-3 px-4"
            data-parent="submenu-builder"
            @click="onRouteClick"
          >
            <faChevronRight class="w-3 fill-primary" />
            {{ $t(child.label) }}
          </RouterLink>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'
import { useToggle } from '@vueuse/core'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()

const props = defineProps({
  menuItem: {
    type: Object,
    required: true
  }
})

const route = useRoute()

const matchedRoute = computed(() => {
  return route.matched.map((m) => m.path)
})

const menuItemWithTogglers = computed(() => {
  const [value, func] = useToggle(false)
  const menuItem = {
    ...props.menuItem,
    toggleFunc: {
      value,
      func
    }
  }

  return menuItem
})

const onRouteClick = () => {
  globalStore.$patch((state) => (state.startbarState = false))
}

const handleAction = (item) => {
  const {
    on_click: { action, params }
  } = item

  if (action == 'downloadManual') {
    const [item, locale] = params
    downloadManual(locale, item)
  }
}

const downloadManual = (locale, item) => {
  var links = [
    globalStore.clientConfig.host + '/manual/new/' + item + '/' + locale + '/echannels.pdf' /*,
            window.config.host + '/manual/' + "amwal" + '/' + language + '/Amwal.pdf'*/
  ]
  var link = document.createElement('a')
  link.setAttribute('download', 'manual_' + locale + '_' + item.label)
  link.style.display = 'none'
  document.body.appendChild(link)
  for (var i = 0; i < links.length; i++) {
    link.setAttribute('href', links[i])
    link.setAttribute('target', '_blank')
    link.click()
  }
  document.body.removeChild(link)
}
</script>

<script>
export default { name: 'SubmenuBuilder' }
</script>

<style lang="scss" scoped></style>
